// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1yk0M","resendInfoText":"OnGoingPaymentBox_resendInfoText__1BhR7"};